import cx from 'classnames';
import React from 'react';
import styles from './ProBadge.mscss';

interface OwnProps {
    className?: string;
}

type Props = OwnProps;

export const ProBadge: React.FunctionComponent<Props> = ({ className }) => (
    <span className={cx(styles.ProBadge, className)}>
        PRO
    </span>
);

ProBadge.displayName = 'ProBadge';
